module.exports = __webpack_public_path__ + "static/media/waiting-payment.41444c00.svg";